export const columnMap = [
    { name: 'Center', header: 'Center', width: 80 },
    { name: 'DateCode', header: 'DateCode', width: 80 },

    { name: 'DDTransplants', header: 'DD<br/>TXPS', width: 60 },
    { name: 'LDTransplants', header: 'LD<br/>TXPS', width: 60 },
    { name: 'WaitlistTotal', header: 'Waitlist<br/>Total', width: 60 },
    { name: 'WaitlistActive', header: 'Waitlist<br/>Active', width: 80 },

    { name: 'LivingDonorsABO_A', header: 'LD<br/>ABO A', width: 60 },
    { name: 'LivingDonorsABO_B', header: 'LD<br/>ABO B', width: 60 },
    { name: 'LivingDonorsABO_AB', header: 'LD<br/>ABO AB', width: 60 },
    { name: 'LivingDonorsABO_O', header: 'LD<br/>ABO O', width: 60 },

    { name: 'LivingDonorRecipientsABO_A', header: 'LD R<br/>ABO A', width: 60 },
    { name: 'LivingDonorRecipientsABO_B', header: 'LD R<br/>ABO B', width: 60 },
    { name: 'LivingDonorRecipientsABO_AB', header: 'LD R<br/>ABO AB', width: 60 },
    { name: 'LivingDonorRecipientsABO_O', header: 'LD R<br/>ABO O', width: 60 },
];